import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ed64852a"), n = n(), _popScopeId(), n);
const _hoisted_1 = { id: "mapbox-container" };
const _hoisted_2 = {
    id: "mapbox-view-container",
    class: "full-parent absolute"
};
const _hoisted_3 = {
    key: 0,
    class: "absolute noselect top-left umbra padding-inline-small padding-block-mini border-round margin-top-left-mini"
};
const _hoisted_4 = { class: "full-parent absolute grid-center text-center info-message" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_LoadingIndicator = _resolveComponent("LoadingIndicator");
    const _component_StateSvg = _resolveComponent("StateSvg");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _withDirectives(_createElementVNode("div", _hoisted_2, null, 512), [
            [_vShow, !_ctx.isOverlayVisible]
        ]),
        _createVNode(_Transition, { name: "mapbox-loading" }, {
            default: _withCtx(() => [
                (_ctx.isServerFlightsLoading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(_component_LoadingIndicator)
                    ]))
                    : _createCommentVNode("v-if", true)
            ]),
            _: 1
        }),
        _withDirectives(_createElementVNode("p", _hoisted_4, "MAPBOX DEACTIVATED", 512), [
            [_vShow, _ctx.isOverlayVisible]
        ]),
        _createVNode(_component_StateSvg, {
            src: "svg/earth.svg",
            class: "absolute top-right margin absolute shadow",
            onClick: _ctx.onClickEarth
        }, null, 8, ["onClick"])
    ]));
}
